import { collectResults } from 'utils/query'
import Styles from './UploadsDrawer.module.scss'
import { UploadedFile } from '../UploadedFile'
import { Button } from 'blaze-ui/Button'
import { useUploadedFiles } from 'hooks/queries/files/useUploadedFiles'
import { IMediaFile } from '../Types'

export const UploadsPanel = () => {
  const uploadsQuery = useUploadedFiles()
  const uploads = collectResults(uploadsQuery, (data) => data.almanac_files) as IMediaFile[]

  const { hasNextPage, fetchNextPage } = uploadsQuery

  return (
    <div>
      <div className={Styles.sectionContainer}>
        <div className={Styles.groupItems}>
          {uploads.map((file) => (
            <div key={file.id} className={Styles.mediaFileContainer}>
              <UploadedFile file={file} />
            </div>
          ))}
        </div>
      </div>
      {hasNextPage && (
        <div className={Styles.seeMoreButton}>
          <Button fullWidth variant="tertiary" size="lg" onPress={() => fetchNextPage()}>
            See More
          </Button>
        </div>
      )}
    </div>
  )
}
